import apiSlice from "./ApiSlice";

/**
 * A DSA retailer's / distributor's Employer Certificate extras: the firm name
 * printed over their profile's, their seal, and their signature (generated
 * from the profile name the first time, reused after that).
 */
export const dsaIssuerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDsaIssuer: builder.query({
      providesTags: ["dsa-issuer"],
      query: (userId: string) => ({
        url: "/dsa-issuer/get",
        params: { userId },
        method: "GET",
      }),
    }),

    updateDsaIssuer: builder.mutation({
      invalidatesTags: ["dsa-issuer"],
      query: ({ userId, firmName }: { userId: string; firmName: string }) => ({
        url: "/dsa-issuer/update",
        params: { userId },
        method: "PUT",
        body: { firmName },
      }),
    }),

    // multipart: field "image"
    uploadDsaIssuerImage: builder.mutation({
      invalidatesTags: ["dsa-issuer"],
      query: ({
        userId,
        kind,
        body,
      }: {
        userId: string;
        kind: "seal" | "signature";
        body: FormData;
      }) => ({
        url: "/dsa-issuer/upload",
        params: { userId, kind },
        method: "PUT",
        body,
      }),
    }),

    removeDsaIssuerImage: builder.mutation({
      invalidatesTags: ["dsa-issuer"],
      query: ({ userId, kind }: { userId: string; kind: "seal" | "signature" }) => ({
        url: "/dsa-issuer/remove",
        params: { userId, kind },
        method: "PUT",
      }),
    }),

    // Saves the signature only when the agent has none; returns the stored one.
    ensureDsaSignature: builder.mutation({
      invalidatesTags: ["dsa-issuer"],
      query: ({ userId, image, name }: { userId: string; image: string; name: string }) => ({
        url: "/dsa-issuer/ensure-signature",
        params: { userId },
        method: "POST",
        body: { image, name },
      }),
    }),

    // Admin "Regenerate": replaces the signature.
    regenerateDsaSignature: builder.mutation({
      invalidatesTags: ["dsa-issuer"],
      query: ({ userId, image, name }: { userId: string; image: string; name: string }) => ({
        url: "/dsa-issuer/generate-signature",
        params: { userId },
        method: "PUT",
        body: { image, name },
      }),
    }),
  }),
});

export const {
  useGetDsaIssuerQuery,
  useUpdateDsaIssuerMutation,
  useUploadDsaIssuerImageMutation,
  useRemoveDsaIssuerImageMutation,
  useEnsureDsaSignatureMutation,
  useRegenerateDsaSignatureMutation,
} = dsaIssuerApi;
